import React from 'react'
import { Card, CardDeck, Col, Row } from 'react-bootstrap'
import { uid } from 'uid';
// import quetzalc from '../../resources/quetzal1.png';

import './Encabezado.css';

export const Resumen = ({resumenes}) => {
    return (
        <div className="encabezado">
            <Row className="row align-items-center justify-content-center">
                <Col md={12} className="mt-1 animate__animated animate__fadeIn">
                    <CardDeck bsPrefix="deck">
                    <Row>
                    {
                        resumenes.map(({titulo, cantidad}) => {
                            return <Col xl={3} md={4} sm={6} className="mb-4" key={uid()}>
                                    <Card>
                                        <Card.Header bsPrefix="tarjeta-header"> { titulo } </Card.Header>
                                        <Card.Body bsPrefix="tarjeta-body"> { cantidad } </Card.Body>
                                    </Card>
                                </Col> 
                        }) 
                    }
                    </Row>
                    </CardDeck>
                </Col>
                {/* <Col md={6} className="d-none d-md-block animate__animated animate__fadeIn">
                    <img src={quetzalc} alt="logo-quetzal" /> 
                </Col> */}
            </Row>
            
        </div>
    )
}
